<template>
  <cargo-advance-select
    :disabled="disabled"
    :select-type="selectTypeNames.static_data_Company"
    :method-params="methodParams"
    :cache="false"
    filterable
    options-width="100%"
    :callback-params="callbackParams"
    :static-options="staticOptions"
    :placeholder="placeholder"
    :headers="headers && headers.length > 0 ? headers: undefined"
    :fields="fields && fields.length > 0 ? fields: undefined"
    :tag-name="tagName"
    :multiple="true"
    :default-multiple-value="defaultValue instanceof Array ? defaultValue : []"
    @enter="enter"
    @parentCallBack="parentCallBack"
  />
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'

export default {
  name: 'CargoHqCompanySelect',
  components: { cargoAdvanceSelect },
  props: {
    disabled: { type: Boolean, default: false },
    defaultValue: { type: [Number, String, Boolean, Array], default: '' },
    methodParams: { type: Object, default: () => { return {} } },
    callbackParams: { type: Object, default: null },
    officeId: { type: Number, default: 0 },
    placeholder: { type: String, default: '' },
    customStyle: { type: String, default: '' },
    headers: { type: Array, default: () => [] },
    fields: { type: Array, default: () => [] },
    tagName: { type: String, default: '' }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      staticOptions: []
    }
  },
  watch: {
    officeId: {
      async handler(newVal) {
        const companyList = await getSpecificBasicData(basicCacheKeys.basic_data_Company)
        let curCompanyList = []
        // 若为HQ 则查询所有合作伙伴
        if (companyList && companyList.length > 0) {
          if (newVal === 1) {
            curCompanyList = [...companyList]
          } else {
            curCompanyList = companyList.filter(p => p.branchId === 1 || p.branchId === newVal || (p.multipleBranchId && p.multipleBranchId.split(',').includes(String(newVal)))) || []
          }
        }
        this.staticOptions = curCompanyList
      },
      immediate: true
    }
  },
  methods: {
    enter() {
      this.$emit('enter')
    },
    parentCallBack(data) {
      this.$emit('parentCallBack', data)
    }
  }
}
</script>

<style>
</style>
